export const DOC_TYPE_ANNOTATION = 'neo4j/doctype';
export const DOC_TOPIC_ANNOTATION = 'neo4j/doctopic';
export const ENTITY_TYPE_DOCUMENTATION = 'documentation';
export const LEGO_BRICK_DOC_TYPE = 'lego-brick';
export const MIGRATION_DOC_TYPE = 'migration';
export const RECORD_DOC_TYPE = 'record';
export const TUTORIAL_DOC_TYPE = 'tutorial';
export const PLAYBOOK_DOC_TYPE = 'playbook';
